import { render, staticRenderFns } from "./filter_catalog.vue?vue&type=template&id=522a07cc&scoped=true&"
import script from "./filter_catalog.vue?vue&type=script&lang=js&"
export * from "./filter_catalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a07cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522a07cc')) {
      api.createRecord('522a07cc', component.options)
    } else {
      api.reload('522a07cc', component.options)
    }
    module.hot.accept("./filter_catalog.vue?vue&type=template&id=522a07cc&scoped=true&", function () {
      api.rerender('522a07cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/filter_catalog.vue"
export default component.exports